import { z } from 'zod'

import type { Language } from '@nxt-insurance/constants'

import { incomeProtectionSchema } from '@flows/configs/de/incomeProtection/types'
import type { generateGetFlowValueFunctions } from '@flows/insurance/utils'

export interface IncomeProtectionStepParams {
  getCurrentLanguage: () => Language
  helperFunctions: ReturnType<typeof generateGetFlowValueFunctions>
  platform: 'web' | 'native'
  environment: string
}

export const hasIncomeProtectionSchema = z.object({
  products: z.object({
    mga_occupational_disability_de: z.object({
      configuration_parameters: incomeProtectionSchema.pick({
        has_income_protection: true,
      }),
    }),
  }),
})

export const illnessSchema = z.object({
  products: z.object({
    mga_occupational_disability_de: z.object({
      configuration_parameters: incomeProtectionSchema.pick({
        illness: true,
      }),
    }),
  }),
})

export const incomeSchema = z.object({
  products: z.object({
    mga_occupational_disability_de: z.object({
      configuration_parameters: incomeProtectionSchema.pick({
        income: true,
      }),
    }),
  }),
})

export const employmentSchema = z.object({
  products: z.object({
    mga_occupational_disability_de: z.object({
      configuration_parameters: incomeProtectionSchema.pick({
        employment_status: true,
      }),
    }),
  }),
})

export const successSchema = z.object({})
